import React, { Fragment, useCallback, useEffect, useMemo, useRef, useState, } from 'react';
import { Button, Checkbox, Divider, Form, Input, Popconfirm, Steps } from 'antd';
import { useTranslation } from 'react-i18next';
import { Steps as StepsIntro } from 'intro.js-react';
import { socketEmitEvent } from '../../../redux/actions';
import { useDispatch, useSelector } from 'react-redux';
import * as SERVICE from '../../../constants/service.types';
import classNames from 'classnames';
import Thumbnail from '../../../assets/images/thumbnail.jpg';
import LinkTag from '../../../components/LinkTag';
import regex from '../../../constants/system.keys';
import InputTag from '../../../components/InputTag';
import CloudBox from '../../../assets/images/cloud-box.png';
import RtspValidate from '../../../assets/images/rtsp-validate.png';
import UsernamePassword from '../../../assets/images/username-password.png';
import UpdateCam from '../../../assets/images/update-cam.png';
import LocationSearchLocationIQ from '../../../components/LocationSearchLocationIQ';
import AddMethod from "./AddMethod";
import ImportListCamera from "./ImportListCamera";

const { Step } = Steps;

const layout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 20 },
};

const RTSPlinkAddCameraComponent = ({ onDone, gatewaySerial, gatewayAddress }) => {
  const ADD_METHOD = useMemo(() => ({
    SINGLE: 1,
    MULTIPLE: 2
  }), []);

  const dispatch = useDispatch();
  /**
   * @param step
   * @type step: 0:scan link, 1:required auth, 2: add camera
   */
  const [isBlock, setIsBlock] = useState(false);
  const [requestId, setRequestId] = useState();
  const [handleScan, setHandleScan] = useState({
    loading: false,
    step: 0,
    data: null,
  });
  const [counter, setCounter] = useState(0);
  const [address, setAddress] = useState({
    note: '',
    lat: '',
    lng: '',
  });
  const source = useRef(null);

  const {
    checkStreamSource,
    updateDevice,
    namespace,
    addExternalDevice,
    dataUser,
    lastVisited,
  } = useSelector((state) => state);
  const [requestHandle, setRequestHandle] = useState({
    step: 0,
    requestId: null,
  });
  const [handleTimer, setHandleTimer] = useState();
  const { t } = useTranslation();
  const refHandleTimer = useRef();
  const [form] = Form.useForm();
  const [formLink] = Form.useForm();
  const [, forceUpdate] = useState();
  const [updateReturn, setUpdateReturn] = useState();
  const [serialSourse, setSerialSourse] = useState();
  const [checkBox, setCheckBox] = useState(false);
  const [dataSteps, setDataSteps] = useState([
    {
      element: ".intro-input-rtsp",
      intro: <div>
        <img alt="" style={{ width: '100%', marginBottom: '8px' }} src={CloudBox} />
        <div>{t('Tích chọn vào “Cloud Box” (Hiển thị ghi chú, chỉ sử dụng khi không có box vật lý)')}</div>
        <img alt="" style={{ width: '100%', margin: '16px 0px 8px' }} src={RtspValidate} />
        <div>{t('Nhập thông tin ghi nguồn Streaming camera test sau đó bấm chọn “Validate”')}</div>
      </div>,
      position: 'left',
    },
    {
      element: ".intro-username",
      intro: <div>
        <img alt="" style={{ width: '100%', marginBottom: '8px' }} src={UsernamePassword} />
        <div>{t('Nhập thông tin xác thực User name và Password. Sau đó nhấn vào “Validate”')}</div>
      </div>,
      position: 'right',
    },
    {
      element: ".intro-add-device",
      intro: 'Nhấn vào “Add device” và chọn “Accept”',
      position: 'right',
    },
    {
      element: ".intro-next",
      intro: 'Nhấn vào “Next”',
      position: 'right',
    },
    {
      element: ".intro-update",
      intro: <div>
        <img alt="" style={{ width: '100%', marginBottom: '8px' }} src={UpdateCam} />
        <div>{t('Nhập tên camera, vị trí của camera. Sau đó bấm chọn “Update”')}</div>
      </div>,
      position: 'right',
    },
  ]);
  const [stepsEnabledStart, setStepsEnabledStart] = useState(false);
  const [stepsEnabled, setStepsEnabled] = useState(false);
  const [initialStep, setInitialStep] = useState(0);
  const [addMethod, setAddMethod] = useState(null);

  useEffect(() => {
    if (dataUser) {
      if (!lastVisited && localStorage.getItem('tutorial') === '1') {
        setTimeout(() => {
          setStepsEnabledStart(true)
          setStepsEnabled(true)
        }, 300);
      }
    }
  }, [dataUser]);


  useEffect(() => {
    forceUpdate({});
  }, []);

  useEffect(() => {
    setRequestId(new Date().getTime());
    return () => {
      setIsBlock(false);
      setHandleScan({
        loading: false,
        step: 0,
        data: null,
      });
      setCounter(0);
      setAddress({ note: '', lat: '', lng: '' });
      setRequestId(null);
      setRequestHandle({
        step: 0,
        requestId: null,
      });
      setUpdateReturn(null);
    };
  }, []);

  useEffect(() => {
    if (source.current) {
      setTimeout(() => { source.current.input.focus() }, 1)
    }
  }, [source]);

  useEffect(() => {
    if (addExternalDevice) {
      setHandleScan((state) => {
        if (addExternalDevice?.serial === state?.data?.serial) {
          return {
            loading: false,
            step: 4,
            data: { ...state.data, isShowFormUpdate: true, loading: false },
          };
        } else return state;
      });
      if (addExternalDevice?.serial === handleScan?.data?.serial) {
        setInitialStep(4)
        setTimeout(() => {
          setStepsEnabled(true)
        }, 300);
      }
    }
  }, [addExternalDevice]);
  useEffect(() => {
    if (updateDevice?.requestId === requestHandle?.requestId) {
      setUpdateReturn(updateDevice);
    }
  }, [requestHandle, updateDevice]);

  useEffect(() => {
  }, [counter]);
  useEffect(() => {
    if (checkStreamSource?.result === 1) {
      setCounter((state) => state + 1);
    }
  }, [checkStreamSource]);

  const onFinishAdd = useCallback(() => {
    form.resetFields();
    setRequestHandle({
      step: 0,
      requestId: null,
    });

    setHandleScan({
      loading: false,
      step: 0,
      data: null,
    });

    return onDone();
  }, [form, onDone]);

  useEffect(() => {
    if (
      requestHandle &&
      updateReturn?.serial &&
      updateReturn.requestId === requestHandle.requestId
    ) {
      setHandleScan((state) => ({
        ...state,
        loading: false,
      }));
      if (updateReturn?.isSuccess) {
        onFinishAdd();
      }
    }
  }, [onFinishAdd, requestHandle, updateReturn]);

  useEffect(() => {
    if (checkStreamSource?.requestId === requestHandle?.requestId) {
      clearInterval(refHandleTimer.current);
      if (checkStreamSource?.result === 1) {
        form.setFields([
          {
            name: 'source',
            errors: [],
          },
        ]);
        setHandleScan({
          loading: false,
          step:
            checkStreamSource?.data?.authenticationRtsp === 'require' ? 1 : 2,
          data: {
            ...checkStreamSource.data,
            isShowFormUpdate: false,
            loading: false,
          },
        });
        if (
          requestHandle.step === 1 &&
          checkStreamSource.data.authenticationRtsp === 'require' &&
          counter > 2
        ) {
          setCounter((state) => state - 1);
          form.setFields([
            {
              name: 'password',
              errors: [t('Username of password is incorrect!')],
            },
            {
              name: 'source',
              errors: [],
            },
          ]);
        }
        if (requestHandle.step === 1 && checkStreamSource.data.authenticationRtsp !== 'require') {
          setInitialStep(2)
          setTimeout(() => {
            setStepsEnabled(true)
          }, 300);
        }
        if (requestHandle.step === 0 && checkStreamSource.data.authenticationRtsp === 'require') {
          setInitialStep(1)
          setTimeout(() => {
            setStepsEnabled(true)
          }, 300);
        }
      } else {
        setHandleScan({ loading: false, step: 0, data: null });
        form.setFields([
          {
            name: 'source',
            errors: [t('Device not found, scan again!')],
          },
        ]);
      }
    }
  }, [checkStreamSource, counter, form, requestHandle, t]);

  useEffect(() => {
    if (handleTimer === 0) {
      setHandleScan((state) => ({ ...state, loading: false }));
      clearInterval(refHandleTimer.current);
      form.setFields([
        {
          name: 'source',
          errors: [t('Timeout, can not find video source stream!')],
        },
      ]);
    }
  }, [form, handleTimer, t]);

  useEffect(() => {
    if (gatewayAddress) {
      form.setFieldsValue({
        location: gatewayAddress?.note ?? '',
      });
      setAddress(gatewayAddress);
    }
  }, [gatewayAddress]);

  const handleAddressChange = (address) => {
    form.setFieldsValue({
      location: address,
    });
    setAddress((state) => ({
      ...state,
      note: address,
    }));
  };

  const handleBack = () => {
    form.resetFields();
    setCounter(0);
    setHandleScan({
      step: 0,
      loading: false,
      data: null,
    });
    setRequestHandle({ requestId: null, step: 0 });
  };

  const handleBackAddDevice = () => {
    formLink.resetFields();
    setHandleScan((state) => ({
      ...state,
      step: 2,
    }));
  };

  const handleSelect = (address) => {
    form.setFieldsValue({
      location: address?.note ?? '',
    });
    setAddress(address);
  };

  const handleAddExternalDevice = useCallback(
    (serial) => {
      formLink.validateFields().then(values => {
        let data = {
          serial,
          namespace,
          extraInfo: {
            ...(checkStreamSource ? checkStreamSource.data : {}),
            subSources: JSON.stringify(values.subSources?.map(item => ({ source: item })))
          },
        };
        if (!values.subSources) {
          delete data.extraInfo?.subSources;
        }
        console.log('data add', data);
        const dataTimeRequest = new Date().getTime();
        setRequestId(dataTimeRequest)
        let dataObj = {
          appServiceType: SERVICE.REQUEST_ADD_EXTERNAL_DEVICE,
          requestId: dataTimeRequest,
          body: JSON.stringify(data),
        };
        setHandleScan((state) => ({
          ...state,
          data: { ...state.data, loading: true },
        }));

        return dispatch(socketEmitEvent(dataObj));
      })
    },
    [checkStreamSource, dispatch, namespace, formLink]
  );

  const handleAddSerialSourse = (serial) => {
    setSerialSourse(serial)
    setHandleScan((state) => ({
      ...state,
      step: 3,
    }));
    setInitialStep(3)
    setTimeout(() => {
      setStepsEnabled(true)
    }, 300);
  }

  const handleUpdateDevice = useCallback(
    (values) => {
      const { serial, name, tags } = values;
      const { note, lat, lng } = address;
      if (serial) {
        let data = {
          note: note ?? "",
          lat: lat ?? 0,
          lng: lng ?? 0,
          serial,
          name: name ? name : serial,
          namespace,
          tags,
        };
        const dataTimeRequest = new Date().getTime();
        setRequestId(dataTimeRequest)
        setRequestHandle((state) => ({
          ...state,
          requestId: dataTimeRequest,
        }));
        let dataObj = {
          appServiceType: SERVICE.UPDATE_DEVICE,
          requestId: dataTimeRequest,
          body: JSON.stringify(data),
        };

        setHandleScan((state) => ({
          ...state,
          loading: true,
        }));
        return dispatch(socketEmitEvent(dataObj));
      }
    },
    [address, dispatch, namespace]
  );

  const onFinish = useCallback(
    (values) => {
      setStepsEnabled(false)
      setHandleScan((state) => ({
        ...state,
        loading: true,
      }));
      setHandleTimer(15);
      refHandleTimer.current = setInterval(() => {
        setHandleTimer((timer) => timer - 1);
      }, 1000);
      const { source, username, password } = values;
      const dataTimeRequest = new Date().getTime();
      setRequestId(dataTimeRequest)
      setRequestHandle({
        step: username && password ? 1 : 0,
        requestId: dataTimeRequest,
      });
      let data = {
        source,
        username,
        password,
        namespace,
        gatewaySerial,
        gatewayType: checkBox ? 'cloud_box' : 'premise_box'
      };
      let dataObj = {
        appServiceType: SERVICE.REQUEST_CHECK_STREAM,
        requestId: dataTimeRequest,
        body: JSON.stringify(data),
      };

      return dispatch(socketEmitEvent(dataObj));
    },
    [dispatch, gatewaySerial, namespace, checkBox]
  );

  const onChangeCheckBox = (e) => {
    setCheckBox(e.target.checked)
  }
  return (
    <>
      {!addMethod && <AddMethod onNext={(method) => setAddMethod(method)} />}

      {addMethod === ADD_METHOD.SINGLE ? (
        <div className="rstp-link-add-camera-component">
          <div className="steps-add-camera">
            <Steps size="small" current={handleScan?.step}>
              <Step title={t('Scan')}/>
              <Step title={t('Validate')}/>
              <Step title={t('Activate')}/>
              <Step title={t('Sourse')}/>
              <Step title={t('Update')}/>
            </Steps>
          </div>
          {handleScan.step === 0 && (
            <div className="guidelines-add-camera">
              <div className="title">{t('Functional support cases')}</div>
              <ul>
                <li>{t('The public camera supports data access via RTSP')}</li>
                <li>{t('Streaming is extracted from traditional receivers')}</li>
                <li>{t('Source re-stream from existing VMS systems')}</li>
              </ul>
            </div>
          )}
          {handleScan.step === 1 && (
            <div className="guidelines-add-camera">
              <div className="title">{t('Streaming requires authentication')}</div>
            </div>
          )}
          {(handleScan.step === 2 || handleScan.step === 4) && handleScan.data ? (
            <div className="add-camera-step-2">
              <div className="add-camera-child">
                <div className="btn-add-camera">
                  {!handleScan?.data?.isShowFormUpdate && (
                    <Fragment>
                      <Button onClick={handleBack}>{t('Back')}</Button>
                      <Popconfirm
                        title={t('Are you sure to add this camera?')}
                        onConfirm={() => {
                          handleAddSerialSourse(handleScan?.data?.serial);
                          setStepsEnabled(false);
                        }
                        }
                        okText={t('Accept')}
                        cancelText={t('Cancel')}
                      >
                        <Button className="intro-add-device" type="primary" loading={handleScan?.data?.loading}>
                          {t('Add device')}
                        </Button>
                      </Popconfirm>
                    </Fragment>
                  )}
                </div>
                <div className="thumbnail">
                  <img
                    className="img-thumbnail"
                    alt={handleScan.data.name}
                    src={
                      handleScan.data.thumbnail?.match(/http/g)
                        ? handleScan.data.thumbnail
                        : Thumbnail
                    }
                  />
                </div>
              </div>

              {handleScan?.data?.isShowFormUpdate && (
                <div className="add-camera-form">
                  <div className="title">
                    Serial: <span>{handleScan.data.serial}</span>
                  </div>
                  <div className="main-form">
                    <Form
                      form={form}
                      {...layout}
                      name="nest-messages"
                      onFinish={(values) => {
                        handleUpdateDevice({
                          name: values.name,
                          location: values.location ?? "",
                          serial: handleScan.data.serial,
                          tags: values.tags?.join(';')?.toLowerCase() || ';',
                        });
                        setStepsEnabled(false);
                      }
                      }
                    >
                      <Form.Item
                        name="name"
                        rules={[
                          {
                            pattern: regex.isName,
                            message: t('Please enter only letters and numbers!'),
                          },
                          {
                            max: 80,
                            message: t('Please input up to 80 characters!'),
                          },
                        ]}
                        label={t('Name')}
                      >
                        <Input
                          className="intro-update"
                          placeholder={`${t('Default name')}: ${handleScan.data.serial
                          }`}
                        />
                      </Form.Item>
                      <Form.Item
                        name="location"
                        rules={[
                          {
                            pattern: regex.isName,
                            message: t('Please enter only letters and numbers!'),
                          },
                          {
                            max: 200,
                            message: t('Please input up to 200 characters!'),
                          },
                        ]}
                        label={t('Location')}
                      >
                        <LocationSearchLocationIQ
                          address={address.note}
                          clearAddress={() => setAddress({note: ''})}
                          onChange={handleAddressChange}
                          onAddressSelect={handleSelect}
                          setIsBlock={setIsBlock}
                        />
                      </Form.Item>
                      <Form.Item
                        name="tags"
                        className="tags-device"
                        label={t('Tag')}
                        style={{borer: '1px solid #434343', borderRadius: '2px'}}
                      >
                        <InputTag numberTag={3} nameAdd="Add tag"/>
                      </Form.Item>
                      <div className="btn-side">
                        <div className="child-btn-side">
                          <Form.Item>
                            <Button onClick={() => {
                              onFinishAdd();
                              setStepsEnabled(false);
                            }}>
                              {t('Skip')}
                            </Button>
                          </Form.Item>
                        </div>
                        <div className="child-btn-side">
                          <Form.Item>
                            <Button
                              type="primary"
                              loading={handleScan.step === 2 && handleScan.loading}
                              htmlType="submit"
                            >
                              {t('Update')}
                            </Button>
                          </Form.Item>
                        </div>
                      </div>
                    </Form>
                  </div>
                </div>
              )}
            </div>
          ) : (
            !(handleScan.step === 3) && (
              <>
                <Checkbox
                  className="checkbox-cloud-box intro-input-rtsp"
                  style={{marginLeft: '27px'}}
                  checked={checkBox}
                  onChange={onChangeCheckBox}
                >Cloud Box
                </Checkbox>
                <div className="validate-rtsp-form" style={{marginTop: '20px'}}>
                  <Form
                    form={form}
                    name="validate-form"
                    layout={handleScan.step === 0 ? 'inline' : 'horizontal'}
                    onFinish={onFinish}
                  >
                    <Form.Item
                      name="source"
                      rules={[
                        {
                          required: true,
                          message: t('Please input rtsp link!'),
                        },
                        {
                          pattern: regex.isurl,
                          message: t('Please input rtsp link!'),
                        },
                        {
                          max: 200,
                          message: t('Please input up to 200 characters!'),
                        },
                      ]}
                    >
                      <Input
                        className="input-rtsp"
                        ref={source}
                        disabled={handleScan.step === 1}
                        placeholder={'rtsp://host:port/path'}
                      />
                    </Form.Item>
                    {handleScan.step === 1 && (
                      <Fragment>
                        <Form.Item
                          name="username"
                          rules={[
                            {
                              required: true,
                              message: t('Please input the username!'),
                            },
                            {
                              pattern: regex.isName,
                              message: t('Please enter only letters and numbers!'),
                            },
                            {
                              max: 80,
                              message: t('Please input up to 80 characters!'),
                            },
                          ]}
                        >
                          <Input className="intro-username" placeholder={t('Username')}/>
                        </Form.Item>
                        <Form.Item
                          name="password"
                          rules={[
                            {
                              required: true,
                              message: t('Please input the password!'),
                            },
                            {
                              pattern: regex.isPassword,
                              message: t('Please input the password!'),
                            },
                            {
                              max: 80,
                              message: t('Please input up to 80 characters!'),
                            },
                          ]}
                        >
                          <Input type="password" placeholder={t('Password')}/>
                        </Form.Item>
                      </Fragment>
                    )}
                    <div
                      className={classNames('validate-btn', {
                        couple: handleScan.step === 1,
                      })}
                    >
                      {handleScan.step === 1 && (
                        <Button onClick={handleBack}>{t('Back')}</Button>
                      )}
                      <Form.Item shouldUpdate={true}>
                        <Button
                          type="primary"
                          loading={handleScan.loading}
                          htmlType="submit"
                        >
                          {t('Validate')}
                        </Button>
                      </Form.Item>
                    </div>
                  </Form>
                </div>
              </>
            )
          )}
          {handleScan.step === 3 && (
            <div className="validate-rtsp-form">
              <Form
                form={formLink}
                name="form_link_sourse"
                layout={handleScan.step === 0 ? 'inline' : 'horizontal'}
              >
                <Form.Item
                  name="subSources"
                  style={{paddingTop: '10px', height: '130px', width: '300px'}}
                >
                  < LinkTag
                    nameAdd={t("Add source")}
                    gatewaySerial={gatewaySerial || checkStreamSource?.data?.gatewaySerial}
                    namespace={namespace}
                  />
                </Form.Item>
                <div
                  className={classNames('validate-btn', {
                    couple: handleScan.step === 1,
                  })}
                >
                  <Button onClick={handleBackAddDevice} style={{marginRight: '10px'}}>{t('Back')}</Button>
                  <Form.Item shouldUpdate={true}>
                    <Button
                      className="intro-next"
                      type="primary"
                      loading={handleScan.loading}
                      onClick={() => {
                        handleAddExternalDevice(serialSourse);
                        setStepsEnabled(false);
                      }}
                    >
                      {t('Next')}
                    </Button>
                  </Form.Item>
                </div>
              </Form>
            </div>
          )}
          <StepsIntro
            enabled={stepsEnabledStart && stepsEnabled}
            steps={dataSteps}
            initialStep={initialStep}
            onExit={() => setStepsEnabled(false)}
          />

          <Divider />

          {handleScan.step === 0 && (
            <div className="btn-back">
              <Button
                type="secondary"
                onClick={() => {
                  setAddMethod(null);
                }}
              >
                {t('Back')}
              </Button>
            </div>
          )}
        </div>
      ) : addMethod === ADD_METHOD.MULTIPLE ? (
        <ImportListCamera
          gatewaySerial={gatewaySerial}
          setAddMethod={(method) => setAddMethod(method)}
          onDone={onDone}
        />
      ) : null}
    </>
  );
};

export default RTSPlinkAddCameraComponent;
